import app from 'js/aofl-js/0.8.0/app/app';
import initServiceImpl from 'readingiq-src/js/riq-js/riq-init-service/1.0.0/index-impl';
import 'readingiq-src/js/riq-js/access-control-service/1.0.0/index';
import 'readingiq-src/js/riq-js/pagearea-tracker-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-auth-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-toastr-service/1.0.0/index';
import 'readingiq-src/js/riq-js/feature-service/1.0.0/index';
import 'readingiq-src/js/riq-js/riq-analytics-service/1.0.1/index';
import 'readingiq-src/js/riq-js/riq-api-service/1.0.0/index';
import 'readingiq-src/js/riq-js/click-tracker-service/1.0.0/index';
import 'readingiq-src/js/riq-js/app-session-state-service/1.0.0/index';

app.registerService('riqInitService', [
  '$rootScope',
  'accessControlService',
  'pageareaTrackerService',
  '$state',
  'applicationDebug',
  'riqErrorHandlerService',
  'riqAuthService',
  'riqToastrService',
  'riqAnalyticsService',
  'riqApiService',
  'clickTrackerService',
  'featureService',
  initServiceImpl
]);
